import { createSlice } from '@reduxjs/toolkit';

export const cryptoWalletsSlice = createSlice({
  name: 'cryptoWallets',
  initialState: {
    cryptoWallets: [],
    isCryptoWallets: false,
  },
  reducers: {
    addCryptoWallet: (state, action) => {
      state.cryptoWallets.push(action.payload);
    },

    removeCryptoWallet: (state, action) => {
      state.cryptoWallets = state.cryptoWallets.filter(wallet => wallet.key !== action.payload.key);
    },

    removeCryptoWalletAll: (state) => {
      state.cryptoWallets = [];
      state.isCryptoWallets = false;
    },


    setCryptoWallets: (state, action) => {
      return { ...state, ...action.payload };
    },
  },
});

export const { addCryptoWallet, setCryptoWallets } = cryptoWalletsSlice.actions;

export default cryptoWalletsSlice.reducer;

